import { articleCssCDN } from './utils';

export function registerCustomElements(): void {
  if (!window.customElements.get('html-block')) {
    window.customElements.define('html-block', HTMLBlock);
  }
}

export class HTMLBlock extends HTMLElement {
  static observedAttributes = ['use-article-styles', 'src'];

  divElement: HTMLDivElement;
  styleElement: HTMLLinkElement;

  constructor() {
    super();
    const shadow = this.attachShadow({ mode: 'open' });

    this.divElement = document.createElement('div');
    this.divElement.className = 'article';
    this.divElement.style.paddingBottom = 'unset';
    this.divElement.style.maxInlineSize = 'unset';
    shadow.appendChild(this.divElement);

    this.styleElement = document.createElement('link');
    this.styleElement.rel = 'stylesheet';
    this.styleElement.type = 'text/css';
    this.styleElement.href = articleCssCDN({ noREMs: true });
  }

  updateSrc(src: string): void {
    try {
      const srcHtml = decodeURIComponent(src);
      this.divElement.innerHTML = srcHtml;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error decoding src in HtmlBlock', e);
    }
  }

  updateStyle(withArticleStyle: string): void {
    const shadowRoot = this.shadowRoot;
    if (!shadowRoot) return;

    if (withArticleStyle === 'true') {
      // Don't add if it's already there
      if (!shadowRoot.contains(this.styleElement)) {
        shadowRoot.appendChild(this.styleElement);
      }
    } else if (shadowRoot.contains(this.styleElement)) {
      // Only remove if it's added
      shadowRoot.removeChild(this.styleElement);
    }
  }

  attributeChangedCallback(
    name: string,
    oldValue: string,
    newValue: string,
  ): void {
    if (name === 'src') this.updateSrc(newValue);
    if (name === 'use-article-styles') this.updateStyle(newValue);
  }
}
